import { render, staticRenderFns } from "./vitasoy-share-card.vue?vue&type=template&id=794b21dc&scoped=true&"
import script from "./vitasoy-share-card.vue?vue&type=script&setup=true&lang=ts&"
export * from "./vitasoy-share-card.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./vitasoy-share-card.vue?vue&type=style&index=0&id=794b21dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b21dc",
  null
  
)

export default component.exports